import axios from "axios";
import { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaCamera } from "react-icons/fa";
import LocationPicker from "../../../utils/LocationPicker";
import { BASE_URL, HEADERS } from "../../../utils/constant";
const AdminProfileModal = ({ show, handleClose, user, fetchUser }) => {
  const [activeTab, setActiveTab] = useState("personal");
  const [profileImage, setProfileImage] = useState(null);
  const [image, setImage] = useState(null);
  const userId = localStorage.getItem("userId");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone_number: "",
    email: "",
    address: "",
    dob: "",
    employees: "",
    radius: 100,
    company_name: "",
    companyAddress: "",
    companyCity: "",
    panNo: "",
    longitude: "",
    latitude: "",

    selectedAddress: "",
    companyContactNo: "",
    companyWebsite: "",
    companyState: "",
    companyPincode: "",
    companyCountry: "",
    companyRegion: "",
    companyLandlineNo: "",
    gstNo: "",
    cinNo: "",

    bankName: "",
    ifscSwift: "",
    accountNumber: "",
    branchAddress: "",
    upiId: "",
    paymentLink: "",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.first_name || "",
        lastName: user.last_name || "",
        phone_number: user.phone_number || "",
        email: user.email || "",
        address: user.primary_address || "",
        dob: user.dob || "",
        employees: user.employees || "",

        company_name: user.company_name || "",
        companyAddress: user.companyAddress || "",
        companyCity: user.companyCity || "",
        panNo: user.panNo || "",
        latitude: user.latitude || "",
        selectedAddress: user.selectedAddress || "",

        longitude: user.longitude || "",
        radius: user.radius ? Number(user.radius) : 100,
        companyContactNo: user.companyContactNo || "",
        companyWebsite: user.companyWebsite || "",
        companyState: user.companyState || "",
        companyPincode: user.companyPincode || "",
        companyCountry: user.companyCountry || "",
        companyRegion: user.companyRegion || "",
        companyLandlineNo: user.companyLandlineNo || "",
        gstNo: user.gstNo || "",
        cinNo: user.cinNo || "",

        bankName: user.bankName || "",
        ifscSwift: user.ifscSwift || "",
        accountNumber: user.accountNumber || "",
        branchAddress: user.branchAddress || "",
        upiId: user.upiId || "",
        paymentLink: user.paymentLink || "",
      });
      setProfileImage(user.profile_image || null);
      setErrors({});
      setSubmitError("");
    }
  }, [user]);

  useEffect(() => {
    if (!show) {
      setErrors({});
      setSubmitError("");
    }
  }, [show]);

  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
      setProfileImage(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    if (
      id === "phone_number" ||
      id === "companyContactNo" ||
      id === "companyLandlineNo"
    ) {
      const numericValue = value.replace(/\D/g, "");
      setFormData({ ...formData, [id]: numericValue });
    } else {
      setFormData({ ...formData, [id]: value });
    }

    setErrors({ ...errors, [id]: "" });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.lastName) newErrors.lastName = "Last Name is required";

    if (!formData.phone_number) {
      newErrors.phone_number = "Phone Number is required";
    } else if (!/^\d{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Phone number must be 10 digits.";
    }

    if (!/^\d{10}$/.test(formData.companyContactNo)) {
      newErrors.companyContactNo = "Number must be 10 digits.";
    }

    if (!/^\d{10}$/.test(formData.companyLandlineNo)) {
      newErrors.companyLandlineNo = "Number must be 10 digits.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }

    if (!formData.employees) newErrors.employees = "Employees is required";
    if (!formData.company_name)
      newErrors.company_name = "Company Name is required";
    if (!formData.companyRegion) newErrors.companyRegion = "Region is required";
    if (!formData.latitude || !formData.longitude) {
      newErrors.latitude = "Please select company location from map";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setSubmitError("Please fill out all required fields properly.");
      return;
    }

    const formDataWithImage = createFormDataWithImage();

    try {
      setLoading(true);

      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${userId}/`,
        formDataWithImage,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response) {
        toast.success("Profile updated successfully!");
        localStorage.setItem("profile_image", response.data.profile_image);
        handleClose();
        fetchUser();
      }
    } catch (error) {
      handleFormErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setSubmitError("");
    setErrors({});
    handleClose();
  };

  const createFormDataWithImage = () => {
    const formDataWithImage = new FormData();

    formDataWithImage.append("first_name", formData.firstName);
    formDataWithImage.append("last_name", formData.lastName);
    formDataWithImage.append("dob", formData.dob);

    if (image) {
      formDataWithImage.append("profile_image", image);
    }
    formDataWithImage.append("email", formData.email);
    formDataWithImage.append("phone_number", formData.phone_number);
    formDataWithImage.append("employees", formData.employees);
    formDataWithImage.append("company_name", formData.company_name);
    formDataWithImage.append("companyAddress", formData.companyAddress);
    formDataWithImage.append("companyCity", formData.companyCity);
    formDataWithImage.append("panNo", formData.panNo);
    formDataWithImage.append("latitude", formData.latitude);
    formDataWithImage.append("selectedAddress", formData.selectedAddress);
    formDataWithImage.append("longitude", formData.longitude);
    formDataWithImage.append("radius", formData.radius);
    formDataWithImage.append("companyContactNo", formData.companyContactNo);
    formDataWithImage.append("companyWebsite", formData.companyWebsite);
    formDataWithImage.append("companyState", formData.companyState);
    formDataWithImage.append("companyPincode", formData.companyPincode);
    formDataWithImage.append("companyCountry", formData.companyCountry);
    formDataWithImage.append("companyRegion", formData.companyRegion);
    formDataWithImage.append("companyLandlineNo", formData.companyLandlineNo);
    formDataWithImage.append("gstNo", formData.gstNo);
    formDataWithImage.append("cinNo", formData.cinNo);
    formDataWithImage.append("bankName", formData.bankName);
    formDataWithImage.append("ifscSwift", formData.ifscSwift);
    formDataWithImage.append("accountNumber", formData.accountNumber);
    formDataWithImage.append("branchAddress", formData.branchAddress);
    formDataWithImage.append("upiId", formData.upiId);
    formDataWithImage.append("paymentLink", formData.paymentLink);
    formDataWithImage.append("primary_address", formData.address);

    return formDataWithImage;
  };

  const handleFormErrors = (error) => {
    if (error.response && error.response.data && error.response.data.error) {
      const errorData = error.response.data.error;

      if (typeof errorData === "object" && !Array.isArray(errorData)) {
        Object.entries(errorData).forEach(([field, messages]) => {
          if (Array.isArray(messages)) {
            messages.forEach((message) => toast.error(`${message}`));
          } else {
            toast.error(`${messages}`);
          }
        });
      }
    }
  };

  return (
    <Modal show={show} onHide={closeModal} size="lg">
      <Modal.Header className="flex-column align-items-stretch border-bottom-0 pb-0">
        <div className="d-flex justify-content-between align-items-center w-100 flex-wrap">
          <div className="d-flex align-items-center">
            <div className="position-relative me-3">
              {profileImage ? (
                <img
                  src={profileImage}
                  alt="Profile"
                  className="rounded-circle border shadow-sm"
                  style={{ width: "80px", height: "80px", objectFit: "cover" }}
                />
              ) : (
                <div
                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "80px",
                    height: "80px",
                    fontSize: "28px",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                >
                  {user?.first_name?.[0] || ""}
                  {user?.last_name?.[0] || ""}
                </div>
              )}

              <label
                htmlFor="profileImageUpload"
                className="position-absolute bottom-0 end-0  rounded-circle "
                style={{ cursor: "pointer" }}
              >
                <FaCamera size={15} className="text-dark" />
              </label>
              <input
                type="file"
                id="profileImageUpload"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />
            </div>

            <div>
              <h5 className="mb-1 fw-semibold text-dark">
                {`${user?.first_name || ""} ${user?.last_name || ""}`.trim()}
              </h5>

              <div className="d-flex align-items-center gap-2">
                <small className="text-muted text-capitalize">
                  {user?.role || "—"}
                </small>

                <span
                  className="badge bg-info text-dark"
                  style={{ fontSize: "12px", padding: "4px 10px" }}
                >
                  SMS Left: {user?.sms_hit_count ?? 0}
                </span>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2 mt-3 mt-sm-0 align-items-center">
            <Button
              variant={activeTab === "personal" ? "primary" : "outline-primary"}
              onClick={() => setActiveTab("personal")}
            >
              Profile
            </Button>

            <Button
              variant={activeTab === "company" ? "primary" : "outline-primary"}
              onClick={() => setActiveTab("company")}
            >
              Company
            </Button>

            <Button
              variant={activeTab === "accounts" ? "primary" : "outline-primary"}
              onClick={() => setActiveTab("accounts")}
            >
              Account
            </Button>
          </div>
        </div>

        {submitError && (
          <div className="w-100 mt-3">
            <Alert variant="danger" className="mb-0">
              {submitError}
            </Alert>
          </div>
        )}
      </Modal.Header>

      <Modal.Body>
        {activeTab === "personal" && (
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group
                  controlId="firstName"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.firstName}
                  />
                  <Form.Label>First Name*</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="lastName" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.lastName}
                  />
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group
                  controlId="phone_number"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Phone Number"
                    value={formData.phone_number}
                    onChange={handleInputChange}
                    isInvalid={!!errors.phone_number}
                  />
                  <Form.Label>Phone Number*</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.phone_number}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="email" className="form-floating mb-3">
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    isInvalid={!!errors.email}
                  />
                  <Form.Label>Email*</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group controlId="address" className="form-floating mb-3">
              <Form.Control
                as="textarea"
                placeholder="Address"
                style={{ height: "60px" }}
                value={formData.address}
                onChange={handleInputChange}
                isInvalid={!!errors.address}
              />
              <Form.Label>Address</Form.Label>
              <Form.Control.Feedback type="invalid">
                {errors.address}
              </Form.Control.Feedback>
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group controlId="dob" className="form-floating mb-3">
                  <Form.Control
                    type="date"
                    placeholder="Incorporation Date"
                    value={formData.dob}
                    onChange={handleInputChange}
                    isInvalid={!!errors.dob}
                  />
                  <Form.Label>Company Incorporation Date</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.dob}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group
                  controlId="employees"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Employees"
                    value={formData.employees}
                    onChange={handleInputChange}
                    isInvalid={!!errors.employees}
                  />
                  <Form.Label>Number of Employees*</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.employees}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}

        {activeTab === "company" && (
          <Form>
            <Row className="mb-3">
              <Form.Group
                controlId="company_name"
                className="form-floating mb-3"
              >
                <Form.Control
                  type="text"
                  placeholder="Company Name"
                  value={formData.company_name}
                  onChange={handleInputChange}
                  isInvalid={!!errors.company_name}
                />
                <Form.Label>Company Name*</Form.Label>
                <Form.Control.Feedback type="invalid">
                  {errors.company_name}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group
                  controlId="companyAddress"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Company Address"
                    style={{ height: "60px" }}
                    value={formData.companyAddress}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyAddress}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.companyAddress}
                  </Form.Control.Feedback>
                  <Form.Label>Company Address</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyCity"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="City"
                    value={formData.companyCity}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyCity}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.companyCity}
                  </Form.Control.Feedback>
                  <Form.Label>City</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyState"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="State"
                    value={formData.companyState}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyState}
                  />
                  <Form.Label>State</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.companyState}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <div className="p-4 mb-4 border rounded-4 bg-light shadow-sm">
              <Row className="align-items-end">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-semibold">
                      Select Company Location*
                    </Form.Label>

                    <LocationPicker
                      setLatitude={(lat) =>
                        setFormData((prev) => ({ ...prev, latitude: lat }))
                      }
                      setLongitude={(lng) =>
                        setFormData((prev) => ({ ...prev, longitude: lng }))
                      }
                      setAddress={(addr) =>
                        setFormData((prev) => ({
                          ...prev,
                          selectedAddress: addr,
                        }))
                      }
                      radius={formData.radius}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.latitude}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  {formData.latitude && (
                    <div className="mt-2 small text-success">
                      Lat: {formData.latitude} <br />
                      Lng: {formData.longitude}
                    </div>
                  )}
                  {formData.selectedAddress && (
                    <div className="mt-2 small text-primary">
                      {formData.selectedAddress}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <Row className="mb-3">
              <Col>
                <Form.Group
                  controlId="companyPincode"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Pincode"
                    value={formData.companyPincode}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyPincode}
                  />
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.companyPincode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyCountry"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Country"
                    value={formData.companyCountry}
                    isInvalid={!!errors.companyCountry}
                    onChange={handleInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.companyCountry}
                  </Form.Control.Feedback>
                  <Form.Label>Country</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyRegion"
                  className="form-floating mb-3"
                >
                  <Form.Select
                    value={formData.companyRegion}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyRegion}
                  >
                    <option value="" disabled>
                      Select Region
                    </option>
                    <option value="North">North</option>
                    <option value="West">West</option>
                    <option value="East">East</option>
                    <option value="South">South</option>
                  </Form.Select>
                  <Form.Label>Region*</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.companyRegion}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group controlId="panNo" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="PAN Number"
                    value={formData.panNo}
                    onChange={handleInputChange}
                    isInvalid={!!errors.panNo}
                  />
                  <Form.Label>PAN Number</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.panNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyContactNo"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Company Contact No"
                    value={formData.companyContactNo}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyContactNo}
                  />
                  <Form.Label>Mobile No.</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.companyContactNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="companyLandlineNo"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Company Landline No"
                    value={formData.companyLandlineNo}
                    onChange={handleInputChange}
                    isInvalid={!!errors.companyLandlineNo}
                  />
                  <Form.Label>Landline No.</Form.Label>
                  <Form.Control.Feedback type="invalid">
                    {errors.companyLandlineNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="gstNo" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="GST Number"
                    value={formData.gstNo}
                    onChange={handleInputChange}
                  />
                  <Form.Label>GST Number</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="cinNo" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="CIN Number"
                    value={formData.cinNo}
                    onChange={handleInputChange}
                  />
                  <Form.Label>CIN Number</Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group
              controlId="companyWebsite"
              className="form-floating mb-3"
            >
              <Form.Control
                type="text"
                placeholder="Company Website"
                value={formData.companyWebsite}
                onChange={handleInputChange}
              />
              <Form.Label>Website</Form.Label>
            </Form.Group>
          </Form>
        )}

        {activeTab === "accounts" && (
          <Form>
            <Row>
              <Col>
                <Form.Group controlId="bankName" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Bank Name"
                    value={formData.bankName}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Bank Name</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="ifscSwift"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="IFSC/SWIFT Code"
                    value={formData.ifscSwift}
                    onChange={handleInputChange}
                  />
                  <Form.Label>IFSC/SWIFT Code</Form.Label>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group
                  controlId="branchAddress"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    as="textarea"
                    placeholder="Branch Address"
                    style={{ height: "100px" }}
                    value={formData.branchAddress}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Branch Address</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="accountNumber"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Account Number"
                    value={formData.accountNumber}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Account Number</Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="upiId" className="form-floating mb-3">
                  <Form.Control
                    type="text"
                    placeholder="UPI ID"
                    value={formData.upiId}
                    onChange={handleInputChange}
                  />
                  <Form.Label>UPI ID</Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  controlId="paymentLink"
                  className="form-floating mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder="Payment Link"
                    value={formData.paymentLink}
                    onChange={handleInputChange}
                  />
                  <Form.Label>Payment Link</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          type="submit"
          disabled={loading}
          variant="primary"
          onClick={handleFormSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "Save"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminProfileModal;
